export const environment = {
  production: true,
  legalAssureApiBaseUrl: 'https://office.legalassure.in:7850/api/',
  whatsAppBaseUrl: 'whatsapp://send',
  marraigeFeedBackUrl: 'https://g.page/r/CefBsUyOkdtDEAE/review',
  bavdhanFeedBackUrl: 'https://g.page/r/CRz1FZDmcFW9EAE/review',
  balewadiFeedBackUrl: 'https://g.page/r/CZOv2yQpZN2eEAE/review',
  externalServiceDetailUrl: 'https://legalassure.in/client-service',
  redirectUri: 'https://office.legalassure.in/'
};
